import { Form } from "@/components/Form"
import { FormRenderMode, FormType } from "@/components/Form/types"
import { forwardRef } from "react"
import isEqual from "lodash/isEqual"
import { useTranslation } from "react-i18next"

interface RxFormProps {
  patientId: string
  caseId: string
  formName: string
  uassistRound: number
  formRenderMode: FormRenderMode
  initialFormData: any
  setInitialFormData: (data: any) => void
  isDataUpdated: boolean
  setIsDataUpdated: (updated: boolean) => void
  setFormRenderMode: (mode: FormRenderMode) => void
  setCurrentFormType: (type: string) => void
  saveAndContinueLater: boolean
  setSaveAndContinueLater: (val: boolean) => void
  formSaveCallBack: () => void
}

const RxForm = forwardRef<any, RxFormProps>((
  {
    patientId,
    caseId,
    formName,
    uassistRound,
    formRenderMode,
    initialFormData,
    setInitialFormData,
    isDataUpdated,
    setIsDataUpdated,
    setFormRenderMode,
    setCurrentFormType,
    saveAndContinueLater,
    setSaveAndContinueLater,
    formSaveCallBack
  }, ref) => {

  const { t } = useTranslation("common")


  return (
    <>
      <Form
        ref={ref}
        details={{
          patientId,
          caseId,
          formType: FormType.UASSIST,
          // formId: addFormId,
          formName,
          uassistRound,
          fetchSavedData: true,
          displayMeta: {
            formTitle:
              formRenderMode === FormRenderMode.EDIT
                ? t("uassist.uDC.refinement")
                : t("uassist.uDC.refinementSummary"),
            formDescription:
              formRenderMode === FormRenderMode.EDIT
                ? null
                : t("uassist.summary.summarydesc"),
          },
        }}
        mode={formRenderMode}
        onChange={(data) => {
          saveAndContinueLater && setSaveAndContinueLater(false)
          if (initialFormData === null) {
            setInitialFormData(data)
          } else if (!isEqual(data, initialFormData)) {
            if (!isDataUpdated) setIsDataUpdated(true)
          } else {
            if (isDataUpdated) setIsDataUpdated(false)
          }
        }}
        onFormSaved={() => {
          // go to summary page
          if(saveAndContinueLater){
            formSaveCallBack()
          }
          else {
            setFormRenderMode(FormRenderMode.SUMMARY)
          }
        }}
        showValidationErrors={false}
        setCurrentFormType={setCurrentFormType}
      />
    </>
  )
})

export default RxForm
